import { useMemo, useState } from "react";
export var GameSettingsKeys;
(function (GameSettingsKeys) {
    GameSettingsKeys["RenderingMode"] = "RenderingMode";
})(GameSettingsKeys || (GameSettingsKeys = {}));
let settings = undefined;
let setSettings = undefined;
export function initGameSettings(initialValues) {
    Object.keys(initialValues).forEach((inputKey) => {
        const localStorageKey = 'gameSettings_' + inputKey;
        const savedSetting = localStorage.getItem(localStorageKey);
        if (savedSetting !== null) {
            initialValues[inputKey] = savedSetting;
        }
    });
    [settings, setSettings] = useState(initialValues);
}
export function useGameSetting(key) {
    return useMemo(() => {
        if (settings === undefined || setSettings === undefined) {
            console.error('Used game settings before initialization!');
        }
        return [settings[key], (newValue) => setSettings((oldSettings) => {
                localStorage.setItem(`gameSettings_${key}`, newValue);
                const newSettingsObject = Object.assign(Object.assign({}, oldSettings), { [key]: newValue });
                return newSettingsObject;
            })];
    }, [key, settings, setSettings]);
}
//# sourceMappingURL=UseGameSetting.js.map